<div class="header">
  <h3>{{'SUBMIT-TO-RD.TITLE' | translate}}</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="searchButtonClicked()" (clear)="clearData()"></app-filter-header>

  <div class="row row-eq-height">
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="company"
          [options]="company"
          [(ngModel)]="selectedCompany"
          (onChange)="filterBranchList()"
          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.COMPANY' | translate}}"
          [style]="{'z-index': 4}"
        >
        </p-dropdown>
        <label for="company">{{'FILTER.COMPANY' | translate}}</label>
      </div>

      <div class="dropdown m-t-10" #dd="ngbDropdown" ngbDropdown autoClose="outside">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange" ngbDropdownToggle
                 placeholder="{{'FILTER.DATE' | translate}}" readonly>
          <label for="calendarDropdown">{{'FILTER.DATE' | translate}}</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
          </div>
          <div (click)="stopPropagation($event)">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="companyBranch"
          [options]="branchList"
          [(ngModel)]="selectedBranch"
          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.BRANCH' | translate}}"
          [style]="{'z-index': 4}"
        >
        </p-dropdown>
        <label for="companyBranch">{{'FILTER.BRANCH' | translate}}</label>
      </div>

      <div class="row align-items-center" style="height: 50%">
        <div class="col-md-auto m-t-10">
          <p-checkbox class="dv-checkbox" binary="true" [(ngModel)]="notSubmittedCompletely"></p-checkbox>
          <span>{{'SUBMIT-TO-RD.ITEMS-NOT-SENT-COMPLETELY' | translate}}</span>
        </div>
      </div>

    </div>
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="documentType"
          [options]="rdDocumentType"
          [(ngModel)]="selectedRdDocumentType"
          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.DOCUMENT-TYPE' | translate}}"
        >
        </p-dropdown>
        <label for="documentType">{{'FILTER.DOCUMENT-TYPE' | translate}}</label>
      </div>
    </div>
  </div>
  <span *ngIf="errorMsg" style="color: #e74c3c;margin-right:10px">{{errorMsg}}</span>
</div>

<div class="box-parent position-relative z-1">
  <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    [maxSize]="5"
    (pageChange)="pageChanged()"
    (optionChange)="searchButtonClicked()"
    *ngIf="no_data === false"
  >
    <div class="row align-items-center">
      <div class="col-auto">
        <button type="button" class="btn btn-dv btn-wide" [disabled]="loading_excel_report"
                (click)="DownloadExcelReport()">
          <i *ngIf="loading_excel_report === true" class="fa fa-spinner fa-spin m-r-5"></i>
          {{'COMMON.DOWNLOAD' | translate}} Excel
        </button>
      </div>
      <div class="col-auto v-divider" *ngIf="canUserDownloadDoc()"></div>
      <div class="col-auto">
        <button type="button" class="btn btn-dv btn-wide" [disabled]="!EnabledDownloadSelected()"
                (click)="submitCheckedToRd(content3);">
          {{'SUBMIT-TO-RD.SUBMIT-TO-RD' | translate}}
        </button>
      </div>
    </div>
  </app-custom-pagination>
  <div class="row m-t-20" *ngIf="no_data === true && loading === false">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>

  <div class="m-t-20 text-center scrollable">
    <p-table #tt tableStyleClass="table" *ngIf="no_data === false" [loading]="loading"
             [columns]="tableCol" [value]="tableDataDisplay" [customSort]="true" (onSort)="sort($event)"
             [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col" *ngIf="canUserDownloadDoc()">
            <p-checkbox class="dv-checkbox" binary="true" (onChange)="selectDeselectAll($event)"></p-checkbox>
          </th>
          <th scope="col">{{'COMMON.TABLE.ORDER' | translate}}</th>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" (click)="pageChanged()">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td *ngIf="canUserDownloadDoc()">
            <p-checkbox *ngIf="(data.total_documents === data.total_approved_docs) && !data.submit_completely"
                        class="dv-checkbox"
                        binary="true" [(ngModel)]="selectedValues[index]"></p-checkbox>
          </td>
          <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
          <td>{{data.header_issue_date}}</td>
          <td>{{data.corporate_branch__name}}</td>
          <td>{{(currentLang === 'en' ? data.rd_document_type_display : data.rd_document_type_display_th)}}</td>
          <td>{{data.total_documents | number: '1.'}}</td>
          <td>{{data.total_approved_docs}}</td>
          <td>{{data.sent_to_rd}}</td>
          <td>
            <i *ngIf="data.submit_completely === true" class="fa fa-check m-r-5"></i>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <!-- <h4 class="modal-title" id="modal-basic-title">Alert</h4> -->
    <button type="button" class="close" aria-label="Close" (click)="revertBack()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        <h5>{{'COMMON.CONFIRM-TRANSACTION' | translate}}</h5>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-danger btn-wide" (click)="revertBack()">
        {{'COMMON.CANCEL' | translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button type="button" class="btn btn-dv btn-wide" (click)="confirm()">{{'COMMON.OK' | translate}}</button>
    </div>
  </div>
</ng-template>

<ng-template #content3 let-modal>
  <div class="modal-body">
    <div class="row" style="margin-bottom: 10px">
      <div *ngIf="loading_all_excel" class="col-12 text-center">
        <i class="fa fa-spinner fa-2x fa-spin" style="margin-left:5px"></i>
        <p>{{'SUBMIT-TO-RD.DOWNLOADING' | translate}} ...</p>
        <br/>
        {{ allExcelCurrent }} / {{ allExcelCount }}
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <span style="color: #4d5f7a">{{sendToRdMessage}}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dv btn-wide p-x-100crem" (click)="closeDownloadAll()">
      {{'COMMON.CLOSE' | translate}}
    </button>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/submit-to-rd/submit-to-rd.component.html